import React from "react";
import PropTypes from "prop-types";

import Footer from "./Footer";
import NavBar from "./NavBar";
import { useLocales } from "../../core/i18n";

/**
 * The standard page shell: skip link, nav, a <main id="main"> landmark, and
 * the footer.
 *
 * Pages used to hand-assemble this, which is how 404.jsx ended up as the one
 * page with no footer. Routing every page through here makes that class of
 * omission impossible rather than merely unlikely.
 */
const PageLayout = ({ children, mainClassName = "", showFooter = true }) => {
	const { t } = useLocales();

	return (
		<div className="min-h-screen bg-pp-bg flex flex-col">
			<a href="#main" className="pp-skip-link">
				{t("ui.skipToContent")}
			</a>
			<NavBar />
			<main id="main" tabIndex={-1} className={`flex-1 ${mainClassName}`.trim()}>
				{children}
			</main>
			{showFooter && <Footer />}
		</div>
	);
};

PageLayout.propTypes = {
	children: PropTypes.node,
	/** Extra classes for the <main> element (container width, padding, etc). */
	mainClassName: PropTypes.string,
	/** Escape hatch for pages that deliberately render without a footer. */
	showFooter: PropTypes.bool,
};

export default PageLayout;
